import { deserialize as deserializeJSONResponse } from 'deserialize-json-api'
import { deserialize } from './serialization'

const intergerizeIds = data => ({
  ...data,
  id: Number(data.id),
  relationships: {
    [Object.keys(data.relationships)[0]]: {
      data: Object.values(data.relationships)[0].data.map(row => ({ ...row, id: Number(row.id) })),
    },
  },
})

export const deserializeResponse = body => {
  if (body?.data) {
    const included = body.included ? body.included.map(row => ({ ...row, id: Number(row.id) })) : []
    const data = body.data.map ? body.data.map(row => intergerizeIds(row)) : intergerizeIds(body.data)

    const transformedBody = {
      included,
      data,
    }

    return deserializeJSONResponse(transformedBody, { transformKeys: 'camelCase' }).data
  }
  return deserialize(body)
}
